import React, { useState } from 'react';
import { updateProductFavorite } from '../services/zohoApi';

const FavoriteButton = ({ product, onFavoriteChange }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    // Vérifier si le produit est favori via le custom field
    const isFavorite = product?.cf_favorite === "true" || product?.cf_favorite === true || 
                      product?.custom_field_hash?.cf_favorite === "true" || 
                      product?.custom_field_hash?.cf_favorite === true;

    const handleToggleFavorite = async () => {
        if (isLoading) return;

        // Si c'est pour supprimer un favori, montrer la confirmation
        if (isFavorite) {
            setShowConfirmModal(true);
            return;
        }

        // Sinon, ajouter directement
        await addToFavorites();
    };

    const addToFavorites = async () => {
        setIsLoading(true);
        try {
            await updateProductFavorite(product.item_id, true);
            onFavoriteChange?.(product.item_id, true);
            
            // Notification de succès
            if (window.showToast) {
                window.showToast(`⭐ ${product.name || product.item_name} ajouté aux favoris`, 'success');
            }
        } catch (error) {
            console.error('Error adding to favorites:', error);
            if (window.showToast) {
                window.showToast('❌ Erreur lors de l\'ajout aux favoris', 'error');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const removeFromFavorites = async () => {
        setIsLoading(true);
        try {
            await updateProductFavorite(product.item_id, false);
            onFavoriteChange?.(product.item_id, false);
            setShowConfirmModal(false);
            
            // Notification de succès
            if (window.showToast) {
                window.showToast(`🗑️ ${product.name || product.item_name} retiré des favoris`, 'info');
            }
        } catch (error) {
            console.error('Error removing from favorites:', error);
            if (window.showToast) {
                window.showToast('❌ Erreur lors de la suppression des favoris', 'error');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <button
                onClick={handleToggleFavorite}
                disabled={isLoading}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: isLoading ? 'default' : 'pointer',
                    fontSize: '16px',
                    padding: '4px',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease',
                    transform: isLoading ? 'scale(0.9)' : 'scale(1)',
                    opacity: isLoading ? 0.6 : 1,
                }}
                title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                onMouseEnter={(e) => {
                    if (!isLoading) {
                        e.target.style.backgroundColor = '#f0f0f0';
                        e.target.style.transform = 'scale(1.1)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isLoading) {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.transform = 'scale(1)';
                    }
                }}
            >
                {isLoading ? (
                    <span style={{ color: '#999' }}>⏳</span>
                ) : isFavorite ? (
                    <span style={{ color: '#ffd700' }}>⭐</span>
                ) : (
                    <span style={{ color: '#ddd' }}>☆</span>
                )}
            </button>

            {/* Modal de confirmation pour la suppression */}
            {showConfirmModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                }} onClick={() => setShowConfirmModal(false)}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        maxWidth: '400px',
                        margin: '20px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                    }} onClick={(e) => e.stopPropagation()}>
                        <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>
                            🗑️ Confirmer la suppression
                        </h3>
                        <p style={{ margin: '0 0 20px 0', color: '#666' }}>
                            Êtes-vous sûr de vouloir retirer <strong>{product.name || product.item_name}</strong> de vos favoris ?
                        </p>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                style={{
                                    padding: '8px 16px',
                                    border: '1px solid #ddd',
                                    backgroundColor: 'white',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                onClick={removeFromFavorites}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 16px',
                                    border: 'none',
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'default' : 'pointer',
                                    opacity: isLoading ? 0.6 : 1,
                                }}
                            >
                                {isLoading ? 'Suppression...' : 'Supprimer'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FavoriteButton;
